import {createAsyncAction, errorResult, registerInDevtools, Store, successResult} from "pullstate";
import {OrganizationViewModel} from "../viewModel/OrganizationView.model";
import {OrganizationService} from "../services/OrganizationServices";


export interface OrganizationStoreInterface {
    organizations: OrganizationViewModel[];
}

const OrganizationStoreInitialValue = {
    organizations: [],
};

export const OrganizationStore = new Store<OrganizationStoreInterface>(OrganizationStoreInitialValue);

registerInDevtools({
    OrganizationStore
});



export namespace OrganizationStoreActions{

    export interface FindAllOrganizationsOutput {
        organizations?: OrganizationViewModel[];
    }
    export const findAllOrganizationsByCognitoId = createAsyncAction<void, FindAllOrganizationsOutput>(
        async (_) => {
            try {
                const result = await OrganizationService.findAllOrganizationsByCognitoId();
                OrganizationStore.update((s) => {
                    s.organizations = result;
                });
                return successResult({ organizations: result });
            } catch (error) {
                return errorResult([], `Couldn't get organizations: ${error}`);
            }
        }
    );

    export const flushStore = () => {
        OrganizationStore.update((x) => {
            x.organizations = OrganizationStoreInitialValue.organizations;
        });
    }
}

